import $ from 'jquery';

const SELECTORS = {
  basket: '.v2-basket',
  body: 'body',
};

const CSS_CLASSES = {
  isOpen: 'is-open',
  mobilePopupOpen: 'mobile-popup-open',
};

const closeBasket = function () {
  $(SELECTORS.basket).removeClass(CSS_CLASSES.isOpen);
  $(SELECTORS.body).removeClass(CSS_CLASSES.mobilePopupOpen);
};

export default closeBasket;
